import React from "react";
import { Box, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import QuantityCounter from "./QuantityCounter";
import { RemoveProductFromCart, UpdateProduct } from "../utils/productInCart";
import {
  REMOVE_ITEM,
  UPDATE_ITEM_AMOUNT,
} from "../features/productInCartSlice";

export default function CartItemActions({
  item,
  product,
  variant = "cart", // cart / preview
}) {
  const dispatch = useDispatch();
  const loggedUser = useSelector((state) => state.user.logedUser);

  const removeFromCart = async () => {
    const result = await Swal.fire({
      title: "בטוח להסיר את המוצר מהעגלה?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "כן, הסר את המוצר!",
      cancelButtonText: "ביטול",
      customClass: {
        popup: "custom-swal",
      },
    });

    if (!result.isConfirmed) return;

   if (loggedUser && typeof item.id === "number") {
  await RemoveProductFromCart(item.id);
}

dispatch(REMOVE_ITEM(item.id));

    Swal.fire({
      title: "מחיקה מהסל!",
      text: "המוצר הוסר מהעגלה!",
      icon: "success",
      timer: 1200,
      showConfirmButton: false,
    });
  };

  const handleAmountChange = async (newAmount) => {
    if (newAmount === item.amount) return;

    if (newAmount <= 0) {
      await removeFromCart();
      return;
    }
if (!loggedUser) {
  dispatch(UPDATE_ITEM_AMOUNT({ id: item.id, amount: newAmount }));
  return;
}

    const productInCart = {
      amount: newAmount,
      customerId: loggedUser.id,
      productId: item.productId,
      productOptionId: item.productOptionId ?? null,
      product: null,
    };

    const res = await UpdateProduct(item.id, productInCart);

    if (res.status === 200) {
      dispatch(UPDATE_ITEM_AMOUNT({ id: item.id, amount: newAmount }));
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <QuantityCounter
        value={item.amount}
        max={product?.quantity}
        onChange={handleAmountChange}
      />

      <IconButton
        size={variant === "preview" ? "small" : "medium"}
        onClick={removeFromCart}
        sx={{
          p: variant === "preview" ? 0.5 : 0,
          color: "black",
        }}
      >
        {variant === "preview" ? (
          <CloseIcon fontSize="small" />
        ) : (
          <DeleteIcon />
        )}
      </IconButton>
    </Box>
  );
}